export default __webpack_public_path__ + "static/media/policy.92b3f549.pdf";